import { getTrack } from '../tracks';
import { Track } from '../sim/track';
import { FIXED_DT_MS } from '../config';
import type { Scenario } from './types';

/**
 * Construit à la volée un scénario de CONDUITE LIBRE : un seul joueur, d'un type de véhicule
 * donné, au départ d'un circuit. Le point de départ est dérivé du circuit (juste après la ligne,
 * cap le long de la tangente) → pas besoin d'un JSON par combinaison circuit×véhicule.
 */
const FALLBACK_TRACK = 'stadium';

export function buildFreeDrive(track: string, vehicle: string): Scenario {
  // Repli sur un circuit CONNU : sinon le monde n'aurait ni piste ni murs et la voiture
  // s'échapperait à l'infini (et le menu se désynchroniserait).
  const name = getTrack(track) ? track : FALLBACK_TRACK;
  const t = new Track(getTrack(name)!);
  const s0 = t.samples[0];
  const spawn = { x: s0.x + s0.tx * 40, y: s0.y + s0.ty * 40, angle: Math.atan2(s0.ty, s0.tx) };
  return {
    name: `free-${name}-${vehicle}`,
    seed: 1,
    track: name,
    fixedDtMs: FIXED_DT_MS,
    cars: [{ id: 'player', spawn, ai: null, vehicle }],
    inputs: [],
    captures: [],
  };
}
